import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/RoomtypesTable.styles'

interface RoomtypeRowSkeletonProps {
  isRoleAdmin: boolean
}

const RoomtypeRowSkeleton: React.FC<RoomtypeRowSkeletonProps> = ({
  isRoleAdmin
}) => {
  const classes = useStyles()

  return (
    <>
      <div
        className={[
          classes.tableRowSkeleton,
          isRoleAdmin ? classes.tableRowSkeletonAdmin : ''
        ].join(' ')}>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        {isRoleAdmin && (
          <>
            <div>
              <Typography variant="body1">
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
            </div>
            <div>
              <Typography variant="body1">
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default RoomtypeRowSkeleton
